import Spin from './common/spin';
import {Suspense} from 'react';
import {useOutlet} from 'react-router-dom';

export default function SuspenseOutlet(): JSX.Element {
  const outlet = useOutlet();

  return <Suspense fallback={<Spin />}>{outlet}</Suspense>;
}
